module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER ONE")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('em', [_vm._v("The English Commercial Empire Expands")])]), _vm._v(" "), _c('p', {
    staticClass: "bqt"
  }, [_vm._v("To found a great empire for the sole purpose of raising up a people of customers may at first sight appear a project fit only for a nation of shopkeepers. It is, however, a project altogether unfit for a nation of shopkeepers; but extremely fit for a nation that is governed by shopkeepers.")]), _vm._v(" "), _c('p', {
    staticClass: "bqright"
  }, [_c('em', [_vm._v("—Adam Smith")]), _vm._v(", The Wealth of Nations")])]), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("By the late sixteenth and early seventeenth centuries, the English had turned their gaze to the wider world, hoping to expand their political power and economic empire. In his "), _c('em', [_vm._v("Discourse of Western Planting")]), _vm._v(" (1584), Richard Hakluyt articulated a commercial strategy that would “yelde unto us all the commodities of Europe, Affrica, and Asia, as far as wee were wonte to travell, and supply the wantes of all our decayed trades.” Besides procuring new resources, exploration and colonization would create markets to “vente” English manufactures and provide “for the manifolde imploymente of nombers of idle men.”")]), _c('a', {
    attrs: {
      "id": "ch1notes-1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes1",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" Surely Hakluyt envisioned the mercantilist mind-set that would produce the “nation governed by shopkeepers” and its consuming subjects that Adam Smith later scorned."), _c('a', {
    attrs: {
      "id": "ch1notes-2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes2",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mercantilism generally posited that if a country encouraged foreign commerce but managed to balance or excel in trade with competing nations, it could accumulate and control a greater portion of global wealth. The state, through its laws and banking system, would promote, protect, and regulate merchant traders in order to raise revenue by duties on the commodities they imported and exported. Simultaneously, home manufacturing would be secured from any foreign or colonial competition by tariffs and restrictions. Of course, some merchants, at least those who flourished under the protection of monopoly charters, supported these policies; others bristled at the interference of regulation that kept them from profitable markets."), _c('a', {
    attrs: {
      "id": "ch1notes-3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes3",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" In that regard, mercantilism was never an entirely coherent or consistent ideology, per se. Still, English merchants usually chose to work with policy makers to find a middle ground between overbearing regulation and unrestrained commerce, hoping to benefit from the intersection of self-interest and national need. In "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("the mid-seventeenth century, Thomas Mun, a member of the increasingly influential, though still emerging, English East India Company (EIC), succinctly described this commercial theory: “The ordinary means to increase our wealth and treasure is by "), _c('em', [_vm._v("Foreign Trade")]), _vm._v(", wherein we must ever observe this rule, to sell more to strangers yearly than we consume of theirs in value.”")]), _c('a', {
    attrs: {
      "id": "ch1notes-4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes4",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" In essence, a nation’s economic success was predicated on gaining access to foreign goods and maintaining a positive balance of trade. Additionally, foreign trade would stimulate industry at home—providing work for merchant marines, shipbuilders, sailors, and shopkeepers—which would lead to new prosperity. As Hakluyt had hoped, consumer societies and commercial empires put “idle men” to work."), _c('a', {
    attrs: {
      "id": "ch1notes-5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes5",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the eighteenth century this mercantilist model came to fruition for Great Britain when commercial organizations acted as its political arm abroad. Indeed, political economists argued that aggressive commercial expansion, rather than warfare alone, would assure the British Empire’s dominance in the global marketplace and enhance its political power. Adam Anderson insisted that “"), _c('em', [_vm._v("Conquest")]), _vm._v(" were to ancient "), _c('em', [_vm._v("Rome")]), _vm._v(", what "), _c('em', [_vm._v("Commerce")]), _vm._v(" is now to other Nations,” an idea that stretched back to the Renaissance."), _c('a', {
    attrs: {
      "id": "ch1notes-6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" James Steuart, in "), _c('em', [_vm._v("An Inquiry into the Principles of Political Oeconomy")]), _vm._v(", argued, “A nation which remains passive in her commerce, is at the mercy of those who are active.”"), _c('a', {
    attrs: {
      "id": "ch1notes-7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes7",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" Not only influenced by shopkeepers, Great Britain increasingly turned to merchants and trade companies to negotiate, finance, and maintain permanent imperial infrastructure at the new “oceanic and territorial peripheries” of empire, regions far different from the maturing colonies of North America."), _c('a', {
    attrs: {
      "id": "ch1notes-8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes8",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" British mercantile enclaves of the early modern period included the West African coast (dominated by the Royal African Company), Mocha and Smyrna (where the Muscovy Company and Levant Company operated), and the beginnings of an English presence in South Asia at Bombay, Madras, and Calcutta."), _c('a', {
    attrs: {
      "id": "ch1notes-9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes9",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" English merchants slowly insinuated themselves into already existing transnational networks of trade, even as these new commercial markets provided a locus for competition between nations of Europe. In the seventeenth century, for instance, the Dutch dominated the pepper and spice trade in Indonesia and Japan, but their primacy gave way slowly under English commercial pressure. Even though merchants had great leeway in how they conducted business, commercial enterprises also relied on British naval power to protect and extend trading activities abroad."), _c('a', {
    attrs: {
      "id": "ch1notes-10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes10",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" Still, the merchants who made foreign trade possible in these enclaves were expected to be the political face of empire, as well as a civilizing force, in essence masking the aggressive, "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("calculating nature of commercial expansion. Foreign trade was a “Means of conveying all Benefits to Mankind,” Adam Anderson optimistically added to his treatise on the "), _c('em', [_vm._v("Origin of Commerce")]), _vm._v(".")]), _c('a', {
    attrs: {
      "id": "ch1notes-11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes11",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("11")])]), _vm._v(" Yet the rise of commercial civility, with its central tenets of contractual law and fair negotiation, just as often posed moral dilemmas for British merchants, who justified some very unethical practices under the guise of peaceful national policies."), _c('a', {
    attrs: {
      "id": "ch1notes-12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes12",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although North America provided Great Britain with raw materials, a place for settlement, and a proving ground for imperial supremacy among European nations, the lands that became known as the East Indies stirred the European commercial imagination. It was no exaggeration when the eighteenth century French cleric Abbé Raynal cited the discovery of “the passage to the East-Indies by the Cape of Good Hope” as “one of the most important events in the history of the human species,” a sentiment Adam Smith reiterated in his "), _c('em', [_vm._v("Wealth of Nations")]), _vm._v("."), _c('a', {
    attrs: {
      "id": "ch1notes-13"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes13",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("13")])]), _vm._v(" Charted by the Portuguese under Vasco da Gama in 1497, the sea route around Africa opened trade between Europe and limited portions of South Asia and countries beyond the Strait of Malacca, including Indonesia, Japan, and China. Well-established port cities such as Goa and Madras in India and Canton in China drew Europeans into vibrant global marketplaces where Persians, Jews, Arabs, Armenians, Indonesians, Japanese, and ethnic Chinese already traded."), _c('a', {
    attrs: {
      "id": "ch1notes-14"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes14",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" Rather than exploiting non-European producers for luxury commodities, English merchants had to trade in markets dominated by Asians, who controlled goods and services. Whereas Raynal insisted that trade with Asia would help all nations “consider themselves as one great society, whose members have all an equal right to partake of the conveniencies of the rest,” because of local limitations, fierce competition broke out among European nations to gain and control access to the East India trade."), _c('a', {
    attrs: {
      "id": "ch1notes-15"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes15",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In order to retain its advantage in the East Indies, Great Britain encouraged merchants to invest in maritime adventures but also struggled to harness and regulate the wealth generated by that trade and the manner in which commercial traders acted abroad. Theoretically, at least, open and free trade abroad would encourage consumption at home and promote new industry and competition in the marketplace, thereby bringing profit to merchants, new markets for English goods, and revenues to the nation through duties and taxes on foreign commodities. William Mildmay, for instance, argued, “The Freedom of Sale is the first general principle so often recommended before, and to which we must again recur, and perpetually adhere, in our commerce abroad as well as in our Trade at home.”"), _c('a', {
    attrs: {
      "id": "ch1notes-16"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes16",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("16")])]), _vm._v(" Yet the British government, and "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("even those who advocated free trade, acknowledged that too much commercial liberty could quickly turn into chaos; individual merchants acting on self-interest could import a glut of certain goods, for instance, that might wreck havoc on pricing and profit, in turn damaging credit markets and tax revenue streams. Mildmay, while promoting the “Freedom of Sale,” also recognized that state-sanctioned charters or corporate monopolies helped rein in excessive commercial activity and were not necessarily an obstacle to expanding trade. Free trade should not be a license for merchants to act freely.")]), _c('a', {
    attrs: {
      "id": "ch1notes-17"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes17",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("17")])]), _vm._v(" Through careful regulation of foreign imports, manufacturing within the empire, and select national monopolies, Great Britain hoped to create dependence on English markets within the empire and to control peripheral economies, even while expanding its presence in the East Indies."), _c('a', {
    attrs: {
      "id": "ch1notes-18"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes18",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("18")])]), _vm._v(" British colonies would supply raw materials and eager consumers for both manufactured goods and foreign reexports. Through regulated domestic and colonial consumption, Britain could maintain its advantageous balance of trade abroad. Still, the incoherence and shifting nature of its so-called mercantilist system created myriad tensions between commercial force and beneficence, between commercial freedoms and restraints, which often triggered unexpected consequences for Great Britain by the eighteenth century.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The English entered commercial competition in the East Indies relatively late. Although individual English trade vessels had plied Asian waters from the early seventeenth century, their efforts were little more than privateering ventures against Portuguese and Dutch ships or trips to purchase goods, such as silks and spices, secondhand from Chinese traders at Bantam (on Java) or from the Portuguese in Surat, on the west coast of India. In the 1640s, however, assisted by a Dutch-Portuguese conflict, the English negotiated a treaty with Portugal to open more formal access to Macao, the gateway to Canton. A “Company of Merchants of London trading to the East Indies,” initially sanctioned by Queen Elizabeth in 1600, emerged as the key player in this commercial chess game. In 1644, merchant Edward Knipe speculated that the company could “reap the Advantages of a Trade between China & India,” provided that its ships carried goods that interested the Portuguese and avoided Dutch intervention at sea."), _c('a', {
    attrs: {
      "id": "ch1notes-19"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes19",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("19")])]), _vm._v(" The group received a new royal charter with expanded powers to build fortifications and raise an army in South Asia, along with territory in Bombay, after Charles II returned to the throne in 1660, clinching its power of governance abroad."), _c('a', {
    attrs: {
      "id": "ch1notes-20"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes20",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("20")])]), _vm._v(" Only in 1709, however, when the “Merchants of London” consolidated commercial forces with a competing "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("company, did the “United Company of Merchants of England trading to the East Indies” (soon known simply as the English East India Company) come into being and start its campaign to become the premier shipper of Asian consumer goods to Great Britain and its colonies. In 1713, the EIC secured rights from the Chinese to enter the port of Canton for trade, and by 1717 it mustered regular, annual commercial voyages to China.")]), _c('a', {
    attrs: {
      "id": "ch1notes-21"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes21",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the benefits of a state-sanctioned monopoly, the EIC became the sole British entity to trade legally between Asia and Great Britain. The author of "), _c('em', [_vm._v("Some Thoughts Relating to Trade in General, and to the East India Trade in Particular")]), _vm._v(" praised the monopoly granted the EIC, since it imported foreign goods that would otherwise have to be purchased through other European nations, at a loss of tax revenue to England. He worried that “the Trade to the "), _c('em', [_vm._v("East Indies")]), _vm._v(" will be entirely lost to this Nation, if it should be laid open.”"), _c('a', {
    attrs: {
      "id": "ch1notes-22"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes22",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" Others worried that a monopoly created economic interdependence between the company and nation, which was potentially disastrous."), _c('a', {
    attrs: {
      "id": "ch1notes-23"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes23",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("23")])]), _vm._v(" Financially, the EIC capitalized itself through subscriptions of stock to investors and issuance of short-term bonds, which provided operating cash. But in practical terms, its financial health was intrinsically tied to the British government, customs revenue, and the national debt. Because the EIC directors and shareholders came from London moneyed interests and had considerable influence on politics, they were able to sustain long-term commercial activity in Asia."), _c('a', {
    attrs: {
      "id": "ch1notes-24"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes24",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("24")])]), _vm._v(" However, the United Company charter of 1709 came with the expectation that the EIC would also provide a cash-strapped nation funds for its wars. By the 1740s, these accumulated loans to government amounted to £4.2 million, for which Parliament assured the company monopoly privileges in Asia and autonomy of its internal affairs. In exchange, the EIC could draw on governmental funds through the Bank of England for short-term loans and working capital. Trading profits paid for generous dividends (consistently 7 to 10 percent yield) distributed among shareholders."), _c('a', {
    attrs: {
      "id": "ch1notes-25"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes25",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("25")])]), _vm._v(" The company was not yet an explicit arm of the British government, as it would become in late-eighteenth-century India, but by midcentury the government and the EIC were mutually dependent on each other to operate and the EIC often acted as the political face of Britain abroad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The main commodity that fueled co-dependence between company and nation, that became the mechanism through which their relationship functioned, was Chinese tea. Although introduced to European elites sometime in the mid-sixteenth century, tea did not become a viable commercial commodity until after 1660 and the Restoration of the Stuart monarchy. Tradition "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("suggests that Catherine of Braganza, daughter of King Juan IV of Portugal, brought a chest of tea to the English court in the 1660s as part of her dowry, which included the islands of Bombay, when she married Charles II.")]), _c('a', {
    attrs: {
      "id": "ch1notes-26"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes26",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("26")])]), _vm._v(" At the turn of the eighteenth century, the poet Edmund Waller dubbed Catherine “the best of Queens” and the tea she made popular “the best of herbs.”"), _c('a', {
    attrs: {
      "id": "ch1notes-27"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes27",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("27")])]), _vm._v(" Tea not only constituted a new luxury good for English consumption but also provided a livelihood to the king and, later, general revenue to the British government. Charles II relied on the “Tonnage and Poundage” paid on many exotic commodities brought from the West and East Indies, including coffee, tea, and chocolate. His brother and successor, James II, received further duties from tobacco and sugar."), _c('a', {
    attrs: {
      "id": "ch1notes-28"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes28",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("28")])]), _vm._v(" By the early eighteenth century, tea and the China trade provided hundreds of thousands of pounds sterling in annual tax revenue for the crown and helped finance the expansion of the British Empire into India and beyond."), _c('a', {
    attrs: {
      "id": "ch1notes-29"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes29",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Because the EIC had political clout and managed currency and credit, which it extended to the government, Great Britain shaped an increasingly complicated tax structure to favor the company and discourage purchase of luxury items through nonsanctioned merchants or outside nations. The New Duties on Coffee, Tea, and Drugs of 1712, for instance, meant to help pay for Queen Anne’s War, gave preference to EIC tea, which was assessed at two shillings per pound, whereas “all kinds of Tea Imported from any other place or places” carried five shillings a pound duty."), _c('a', {
    attrs: {
      "id": "ch1notes-30"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes30",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("30")])]), _vm._v(" Great Britain also attempted to control the flow and distribution of EIC commodities in order to track and collect revenues. It presumably collected about £264,534 in revenue on 2,645,337 pounds of tea imported by the EIC during the 1710s ("), _c('a', {
    attrs: {
      "href": "#/xhtml/ch1#table1.1"
    }
  }, [_vm._v("table 1.1")]), _vm._v("). The British government also required company merchants to identify tea that would be consumed in England versus that slated for reexport, for which the EIC received drawbacks (or rebates) on tax duties. Further, the EIC was required to warehouse and certify all tea before sale at auction."), _c('a', {
    attrs: {
      "id": "ch1notes-31"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes31",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("31")])]), _vm._v(" Throughout the early eighteenth century, the EIC and Parliament heatedly negotiated the amount of import duties imposed on tea and other East India goods. The EIC worried that too much tax would choke consumer ability to purchase these goods and ultimately hurt its sales and decrease state revenue; even the Commissioners of the Customs, in “their own private opinions,” believed that lower tax duties would ultimately “bring more to the Crown.”"), _c('a', {
    attrs: {
      "id": "ch1notes-32"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes32",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("32")])]), _vm._v(" Still, the British government most often won the battle to control taxation and the cost of foreign trade; it took advantage of importation, reexportation, and growing domestic usage of tea to raise revenue.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "table1.1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TABLE 1.1")])])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("English East India Company (EIC) Tea Imported to England (in lbs.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0019-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('em', [_vm._v("Source")]), _vm._v(": Data for the EIC General Ledgers figures are compiled from K. N. Chaudhuri, "), _c('em', [_vm._v("The Trading World of Asia and the English East India Company, 1660–1760")]), _vm._v(" (Cambridge: Cambridge University Press, 1978), 388, and Earl H. Pritchard, "), _c('em', [_vm._v("Anglo-Chinese Relations During the Seventeenth and Eighteenth Centuries")]), _vm._v(" (New York: Octagon Books, 1970), Appendix XIX: “East India Company’s Tea Trade,” n.p. Data for the Board of Customs are compiled from Great Britain, Board of Customs & Excise, Ledgers of Imports and Exports, 1696–1780, in the Public Records Office, London, reels 3–37.")])]), _c('p', {
    staticClass: "indentt"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("During the first half of the eighteenth century, the importation and sale of Chinese tea increased dramatically and provided a reliable, taxable commodity. By the 1740s, EIC tea imports to England had risen more than twentyfold, prompting the British government to add distribution and consumption taxes to tea (see ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/ch1#table1.1"
    }
  }, [_vm._v("table 1.1")]), _vm._v("). In the 1720s, Robert Walpole, chancellor of the exchequer and effective prime minister, reformed the import tax structure, adding an inland duty of four shillings per pound on “all Tea [to] be sold in Great Britain.” Walpole’s Act of 1724 required that everyone, from the EIC merchant and local wholesaler to “every Druggist, Grocer, Chandler, Coffeehouse-keeper, [and] Chocolate-house keeper,” pay a duty and provide certificates for any tea purchased for retail sale or public consumption."), _c('a', {
    attrs: {
      "id": "ch1notes-33"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes33",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("33")])]), _vm._v(" After nearly a decade of revenue collection, Walpole lauded the taxes on tea, coffee, and chocolate as paramount to paying down the national debt, which was only possible by “"), _c('em', [_vm._v("that alteration")]), _vm._v(" . . . made "), _c('em', [_vm._v("in the then method of collecting these revenues")]), _vm._v(".” He defended his revenue bill, arguing “that considerably above a "), _c('em', [_vm._v("million of money")]), _vm._v(" has been paid into the "), _c('em', [_vm._v("Exchequer")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MORE")]), _vm._v(" in the last eight years, than in the former.”"), _c('a', {
    attrs: {
      "id": "ch1notes-34"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes34",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("34")])]), _vm._v(" Between 1721 and 1730, with 9,129,049 pounds of tea imported, the Board of Customs could have collected as much as £1.8 million in inland duties alone (see "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch1#table1.1"
    }
  }, [_vm._v("table 1.1")]), _vm._v("). Still, the mercantilist policies that emerged from negotiation between company and nation, although mutually beneficial, left merchants with a series of practical problems to overcome. The EIC had to establish a commercial presence in China, which entailed forcing open notoriously restrictive Chinese markets. It had to ward off English interlopers and "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("smugglers, surpass the European competition, and find viable commodities of exchange. Before the 1740s, these tasks proved far more complicated than expected.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("From its base of operations in Madras (Fort St. George), the EIC successfully expanded its commercial empire with the help of nationally sanctioned monopoly powers. Still, the company struggled to find its footing in Asian markets restricted by Chinese trade policies and procedures that stymied the EIC’s strategy and influence over the emerging tea trade. The Chinese emperor, through regional Mandarins, controlled all commerce in China. Prior to the seventeenth century, the imperial government discouraged maritime trade by banning foreign travel of Chinese nationals, curtailing supplies to coastal regions, and burning ships. But Chinese merchants, even ordinary people, evaded government edicts to trade a variety of consumer goods at ports throughout South Asia and Indonesia, forcing the government to open Chinese markets to outsiders.")]), _c('a', {
    attrs: {
      "id": "ch1notes-35"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes35",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("35")])]), _vm._v(" In the mid-seventeenth century, acknowledging that “commerce is a way to enrich our nation, and to open foreign trade is a special means of raising income (from taxation),” the recently ascendant Qing emperor granted Portuguese in residence at Macao access to Canton, opening the way for other European traders in 1684."), _c('a', {
    attrs: {
      "id": "ch1notes-36"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes36",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" By the turn of the eighteenth century, imperial Mandarins and local Hoppos, who oversaw customs collection and port activities, had created a complicated set of rules for foreign commerce in China. They restricted foreign trade to Canton alone, allowing Europeans temporary residence only during the trade season. In the 1720s, the English had “no settled Factory at "), _c('em', [_vm._v("Canton")]), _vm._v("” and were “only permitted to hire large "), _c('em', [_vm._v("Hongs")]), _vm._v(", or "), _c('em', [_vm._v("Houses")]), _vm._v(", near the water side, conveniently accommodated with ware-houses to receive their goods before they are shipp’d off.”"), _c('a', {
    attrs: {
      "id": "ch1notes-37"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes37",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("37")])]), _vm._v(" When Europeans did come to port, the Hoppos usually boarded their ships in Macao or Whampo, three miles outside of Canton, to oversee the surrender of any arms and “to see that nothing is smuggled out of or into the ship.” The Hoppos searched every crate and piece of cargo, complained "), _c('em', [_vm._v("The Chinese Traveller")]), _vm._v(", “and sometimes even our pockets do not escape them.”"), _c('a', {
    attrs: {
      "id": "ch1notes-38"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes38",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("38")])]), _vm._v(" A series of fees and charges had to be paid by foreign traders in silver, including import and export duties on goods brought in and purchased. Besides a measurage charge based on length and tonnage of each vessel, additional presents, some may say bribes, to various officials—the linguist (translator), weigher, Hoppo, security officer, and Mandarin—greased the wheels of commerce."), _c('a', {
    attrs: {
      "id": "ch1notes-39"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes39",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0021-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "figcap"
  }, [_vm._v("Ports of Trade in The East Indies, 1700–1740. Map by Taya Barnett, Old Dominion University.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("The cost of doing business in China was high, but the English objected most to the restricted access to the goods and services of local merchants, which hurt the EIC’s ability to negotiate direct competitive contracts. Since there was no permanent post in Canton, the EIC sent teams of supercargoes (merchant agents for the company who also had rights to limited private trade) with each ship that entered port. Laden with instructions from the company directors at Fort St. George in Madras, where all orders originated, each ship, captain, and agent recorded his experiences for the China Diary and Consultations so that future ventures could deal more effectively with Chinese trade policies, merchants, and commodity pricing.")]), _c('a', {
    attrs: {
      "id": "ch1notes-40"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes40",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("40")])]), _vm._v(" Throughout the early eighteenth century, EIC agents “demanded a free Trade with all people without restriction” from officials at Canton."), _c('a', {
    attrs: {
      "id": "ch1notes-41"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes41",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("41")])]), _vm._v(" In 1704, for instance, the Hoppo at Canton prevented an English merchant named Alexander Hamilton from directly hiring river pilots or linguists to take his goods to market. Hamilton found that “no Merchants came near me,” making him suspect that local officials and merchants had conspired to engage or threaten every available linguist, forcing him and other European traders to contract with a sanctioned group of dealers who set the price of goods “40 and 50 "), _c('em', [_vm._v("per Cent.")]), _vm._v(" higher” than the current, open market."), _c('a', {
    attrs: {
      "id": "ch1notes-42"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes42",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("42")])]), _vm._v(" By midcentury, the Hoppos at Canton required that English traders negotiate only with particular Hong merchants who had paid off local authorities for exclusive rights to oversee trade with Europeans. The Hong merchants could set prices, arrange the sale of goods, and rent facilities to foreign merchants, reaping higher fees on their exclusive contracts. However, they also had to put up security against any problems that might arise from European merchant or mariner behavior in Canton."), _c('a', {
    attrs: {
      "id": "ch1notes-43"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes43",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("43")])]), _vm._v(" With a few sanctioned merchants in place to service all Europeans, the EIC merchants felt disadvantaged as competition for Chinese commodities increased. In 1719, supercargoes William Fazakerley, Robert Gascoigne, and Whichcott Turner of the "), _c('em', [_vm._v("Carnaroon")]), _vm._v(" complained, “Tea was growing excessive dear, from the great demand, and preknowledge the Chinese had of our arrival.”"), _c('a', {
    attrs: {
      "id": "ch1notes-44"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes44",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0022-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "figcap"
  }, [_vm._v("Jacobus van der Schley, "), _c('em', [_vm._v("Kaart van’t Inkoomen der Riviere van Kanton / Carte de l’Entrée de la Riviere de Canton, Dressée sur les Observations les plus récentes")]), _vm._v(", 1749. From "), _c('em', [_vm._v("Atlas of Mutual Heritage and the Koninklijke Bibliotheek")]), _vm._v(". Courtesy National Library of the Netherlands. Public Domain under a Creative Commons Public Domain Dedication (CC-ZERO).")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Despite the restrictions placed on access to Chinese markets, English merchants quickly garnered expertise in every aspect of tea production, packaging, and shipment, purchasing more and greater variety with each passing year. Usually cultivated and harvested by tenants on small farms in the hills of nearby Fujian Province, all varieties of tea leaves sold in Canton came from the same plant species, although raised in slightly different soils and picked at different times during the growing season. The drying and curing process was labor intensive and painstaking. Most tea leaves were dried in flat baskets, heated in a caldron over a fire, and turned by hand before packing.")]), _c('a', {
    attrs: {
      "id": "ch1notes-45"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes45",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("45")])]), _vm._v(" Initially, the EIC agents under consultation in Canton purchased mainly Singlo, a delicate variety of green tea “most valued and used in China,” according to one observer."), _c('a', {
    attrs: {
      "id": "ch1notes-46"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes46",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("46")])]), _vm._v(" Merchants thought green teas, whose qualities were judged by smell and taste, to be the most profitable and easily resold “to all Parts of the World, where they have the Knowledge of it.”"), _c('a', {
    attrs: {
      "id": "ch1notes-47"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes47",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("47")])]), _vm._v(" In 1719, 75 percent of the teas sold at the EIC’s London auction were green teas and during the 1720s, Singlo represented more than 50 percent of all Chinese tea imported to England ("), _c('a', {
    attrs: {
      "href": "#/xhtml/ch1#table1.2"
    }
  }, [_vm._v("table 1.2")]), _vm._v(")."), _c('a', {
    attrs: {
      "id": "ch1notes-48"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes48",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("48")])]), _vm._v(" Within a few decades, however, company agents shifted to a cheaper black tea variety, Bohea, which proved more durable during long sea voyages. By the 1740s, barely 30 percent of the EIC’s imports consisted of green tea. The EIC even changed its storage and shipping procedures to accommodate increasing amounts of tea purchased. After local Chinese laborers tramped down the tea by foot into lead-lined chests, English traders inspected “one chest in five of all the Green Tea” to check for damaged product."), _c('a', {
    attrs: {
      "id": "ch1notes-49"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes49",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("49")])]), _vm._v(" By standardizing the size and tare of tea chests, the company could maximize storage capacity for outgoing vessels. The "), _c('em', [_vm._v("Macclesfield")]), _vm._v(", which arrived in Canton late summer 1724, was instructed only to use chests in which “the Wood be first season’d and . . . Take care that no Camphire be Laden with the Tea in this Ship least its Scent spoil it.”"), _c('a', {
    attrs: {
      "id": "ch1notes-50"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes50",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("50")])]), _vm._v(" Supercargoes discovered that chinaware cushioned by rice straw provided the best ballast for their ships and did not emit any smell that might further contaminate the tea."), _c('a', {
    attrs: {
      "id": "ch1notes-51"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes51",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("51")])]), _vm._v(" The EIC used every free nook and cranny of a ship to stow tea, including “the after hould” and “the Breadroom,” even stashing tea “Between Decks, and abaft the Well in the Hold.”"), _c('a', {
    attrs: {
      "id": "ch1notes-52"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes52",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "table1.2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TABLE 1.2")])])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Types of Tea Imported to Great Britain by the EIC (in lbs.)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0024-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('em', [_vm._v("Source")]), _vm._v(": Compiled from K. N. Chaudhuri, "), _c('em', [_vm._v("The Trading World of Asia and the English East India Company, 1660–1760")]), _vm._v(" (Cambridge: Cambridge University Press, 1978), 397–98. The higher quality black teas, Pekoe and Souchong, represented less than 2% of the total EIC imports, while lower grades of Congou and Bohea made up 7% and 38%, respectively, in the first four decades of the century. Bohea tea, which was a black tea from Fujian Province, eventually became the most popular in Europe and the Americas during the eighteenth century.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Even though the EIC gained access to the Canton tea market by the 1720s, it struggled with a growing presence of commercial interlopers from England and smugglers from many nations that undermined the company’s monopoly charter rights. Paradoxically, supercargoes brought tea home legally as part of their personal compensation package, some of which never reached London port, let alone the EIC warehouse and auction. Company agents, enticed by potential profits, at times certified for “reexport” tea from their “private trade” along with product from the regular cargo manifest. They could then receive a drawback (rebate) on the inland duty, after which they would land the tea elsewhere along the coast of Wales or England to be resold illegally.")]), _c('a', {
    attrs: {
      "id": "ch1notes-53"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes53",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("53")])]), _vm._v(" Still, this “fictitious export trade” was less damaging to the EIC sales than teas smuggled directly into England from across the Channel. Swedish and Danish merchants infiltrated Scotland and northern England, while the Dutch and French plied coastal waters from the south. Smuggling had become commonplace in England after 1721, especially through the Isle of Man and Channel Islands, providing extra work for law enforcement and exciting tales of chase and capture for the media. In December 1734, newspapers across the Atlantic carried stories of local officers in Winchelsea and Pett, who “with three "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Dragoons, seized and carried to his Majesty’s Warehouse” 2,559 pounds of tea.")]), _c('a', {
    attrs: {
      "id": "ch1notes-54"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes54",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("54")])]), _vm._v(" A parliamentary committee investigating smuggling in 1745 estimated that after 1721, of the estimated 3 million pounds of tea consumed at home per year, 2 million pounds were “openly, and in Defiance of the Laws and the Civil Government, smuggled and run in.”"), _c('a', {
    attrs: {
      "id": "ch1notes-55"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes55",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Faced with restrictions on Chinese trade and the commercial threat of European smugglers, the EIC developed a strategy to corner the tea market. Between 1720 and 1740, the Court of Directors instructed supercargoes to systematically “engross,” or purchase, as much tea as possible to keep the commodity out of the hands of French, Dutch, Danish, or Swedish competitors who patronized the Canton markets. Of great concern was the Flemish Ostend Company, chartered by the Austrian emperor, which acted as a front for English, Scottish, and Dutch merchants denied legal access to Asian markets by the EIC’s monopoly powers. In 1720, EIC agents attempted to purchase “all the Tea procurable that is either very good, or but tolerable, and not damaged,” no matter the cost. They hoped to “make these Interlopers sick of their voyages, which can never be done unless they are prevented getting Tea.”"), _c('a', {
    attrs: {
      "id": "ch1notes-56"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes56",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("56")])]), _vm._v(" The attempt to corner the tea market, especially highly desirable green tea, eventually expanded. In 1729, the EIC instructed its agents to quickly buy up all the green tea that Chinese merchants could supply, “sufficient to prevent the Ships coming after us of obtaining any quantity.” As a further precaution, the agents agreed to buy future contracts for Bohea tea in case additional European traders arrived unexpectedly."), _c('a', {
    attrs: {
      "id": "ch1notes-57"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes57",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("57")])]), _vm._v(" With little concern for the quality, and no clear connection to increased consumer demand, the EIC simply wanted to take as much tea out of the hands of its competitors as needed to secure a market for company tea at home and the European reexport markets."), _c('a', {
    attrs: {
      "id": "ch1notes-58"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes58",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1727, the Ostend Company lost its charter and went out of business under pressure from the Dutch, who quickly became the EIC’s chief rival for Chinese tea. Although the Anglo-Dutch wars had ended long before, English and Dutch merchants fought each other ruthlessly in the economic arena. During the seventeenth century, the Dutch aggressively inserted themselves into the political and commercial lives of the Javanese, dominating the spice trade from a base at Batavia."), _c('a', {
    attrs: {
      "id": "ch1notes-59"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes59",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("59")])]), _vm._v(" The Dutch bought only certain Chinese commodities indirectly during the first twenty years of the eighteenth century, either through Batavian markets or from other European merchants. Paradoxically, Holland became the most important reexport market for EIC tea. From 1700 to 1710, the Dutch purchased 269,010 pounds of Chinese tea from "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("English merchants, or one-third of the EIC’s total sales. The following decade, they imported 649,462 pounds of tea, one-quarter of all the tea that the EIC sold. During the first three years of the 1720s, Holland bought an astounding 1,196,984 pounds of tea from England.")]), _c('a', {
    attrs: {
      "id": "ch1notes-60"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes60",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("60")])]), _vm._v(" However, Dutch buying habits changed dramatically during the late 1720s, after the Dutch East India Company ruined a group of British traders at Mocha (Yemen). The Dutch company had bid up the price of coffee without eventually buying any, effectively blocking English access to that commodity. The EIC, hoping to prevent a similar disaster to its business in Canton, stepped up efforts to monopolize the Chinese tea market, cut back reexports to Holland, and successfully obstructed Dutch commerce in China."), _c('a', {
    attrs: {
      "id": "ch1notes-61"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes61",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("61")])]), _vm._v(" During the 1729–1730 season, company agent William Fazakerley even tried to promote cooperation with Britain’s perpetual enemy, the French, in order to marshal their “mutual interest . . . to hinder the Dutch trading to China.”"), _c('a', {
    attrs: {
      "id": "ch1notes-62"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes62",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("62")])]), _vm._v(" But English merchants found that the French also sought to monopolize the tea trade. In December 1730 company agents swore to the directors that they were blameless for failing “to engross the Green Tea,” since the French ship "), _c('em', [_vm._v("Mars")]), _vm._v(" had arrived before them. Still, EIC agents prevented “the French Gentlemen” from procuring “but little more than one half of what they intended to purchase,” promising to send a large quantity of tea home in their vessels."), _c('a', {
    attrs: {
      "id": "ch1notes-63"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes63",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The EIC’s machinations failed to undermine Dutch or French access to tea, however. Instead it helped initiate a frenzy of commercial activity in Asia by a growing number of European traders, allowed competing companies to smuggle cheap tea into England, and produced a glut of tea at home. Although the total sales of EIC goods surpassed the Dutch, by the 1740s Dutch merchants managed to purchase comparable amounts of tea directly from Canton, even as the EIC lost Dutch customers for tea reexports ("), _c('a', {
    attrs: {
      "href": "#/xhtml/ch1#table1.3"
    }
  }, [_vm._v("table 1.3")]), _vm._v("). The Danish and Swedish East India Companies also increased direct trade with China, perhaps allowing other European nations like Germany and Flanders to stop purchasing tea from the EIC altogether by midcentury. Conversely, Dutch, French, Danish, and Swedish merchants were able to smuggle tea back into Great Britain and still sell it for less than the EIC auction price, thus further undermining the company’s trade monopoly."), _c('a', {
    attrs: {
      "id": "ch1notes-64"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes64",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "table1.3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TABLE 1.3")])])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("English versus non-English Tea Importations (in lbs.)")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0027-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap1"
  }, [_c('em', [_vm._v("Source")]), _vm._v(": Louis Dermigny, "), _c('em', [_vm._v("La Chine et l’Occident: Le commerce à Canton au XVIII")]), _c('sup', [_vm._v("e")]), _vm._v(" "), _c('em', [_vm._v("siècle, 1719–1833")]), _vm._v(" (Paris: École pratique des hautes études, 1964), 2:539. Although some dispute the accuracy of his numbers, Dermigny is one of the few sources that provide comparative figures for several nations.")]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('em', [_vm._v("Notes")]), _vm._v(": Dermigny’s figures, originally in piculs, have been converted to pounds using the formula 1 picul = 133.33 lbs. Em dash indicates data not available.")])]), _c('p', {
    staticClass: "indentt"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("The EIC’s decision to purchase increasing amounts of Chinese tea in the early decades of the eighteenth century generated competition among European merchant companies but also placed pressure on tea production and distribution networks within China. Chinese officials tried to control foreign trade and traffic, but their participation in the new global economy made them increasingly dependent on foreign merchants. By the late 1720s, demand for tea by European traders had risen so sharply that Canton producers had trouble supplying the market. The EIC agents on "), _c('em', [_vm._v("Prince Augustus")]), _vm._v(" reported to company directors in 1728 that only one merchant, Suqua, could obtain any great quantity of teas since two or three years of heavy taxation by the Mandarins and falling profits had curtailed production of green tea especially.")]), _c('a', {
    attrs: {
      "id": "ch1notes-65"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes65",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("65")])]), _vm._v(" The more tea that the EIC and other European trade companies ordered, the more Chinese merchants exerted power over the supply of the commodity, attempting to keep the price high."), _c('a', {
    attrs: {
      "id": "ch1notes-66"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes66",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("66")])]), _vm._v(" In 1729, EIC agents tried to negotiate exclusive contracts with cooperative merchants; Suqua, for instance, helped the EIC monopolize the green tea market in the 1720s and 1730s. However, more Canton merchants, including Suqua, undercut the company’s contracts by selling to other European traders and colluding with other Chinese merchants to set prices and control distribution."), _c('a', {
    attrs: {
      "id": "ch1notes-67"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes67",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("67")])]), _vm._v(" Soon every small merchant in Canton “who expected any Business with the Europeans” had joined a frenzy of speculative buying from countryside tea growers."), _c('a', {
    attrs: {
      "id": "ch1notes-68"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes68",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("68")])]), _vm._v(" High demand led to hasty orders and little quality control; at times Chinese producers and merchants mixed old or cheaper teas with new crops to get product to market quickly. The EIC agents complained in 1730 that the unusual demand for tea from the year before inspired Canton merchants to provide “incredible Quantities of Tea, or rather something like Tea,” to fill their current contracts."), _c('a', {
    attrs: {
      "id": "ch1notes-69"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes69",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the mid-1730s, an elite Chinese merchant syndicate called the Co-Hong emerged using their wealth to buy favor from imperial Mandarins and appropriate exclusive trade rights with all foreigners. The Co-Hong’s rise to power further delimited the EIC’s ability to directly hire or fire local workers, pay duties on goods brought off ship, and control the parameters of commercial "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("contracts. In 1736, supercargo Andrew Reid warned the company directors about the potential power of the Co-Hong cartel over the sale of teas. Calling it a “Secret Combination,” Reid and his colleagues pondered how “to prevent if possible, the Teas from falling into their Hands, & our being at their discretion for them.”")]), _c('a', {
    attrs: {
      "id": "ch1notes-70"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes70",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("70")])]), _vm._v(" The persistence of the Co-Hong and pressures from the EIC agents in Canton led to growing disagreements over contract provisions, taxes, credit, payments, and the quality of tea. For instance, when the Chinese emperor Qianlong (Ch’ien-Lung) liberalized imperial tax policy in 1736, including the abolition of a supplemental 10 percent tax on foreign silver entered for trade, the company agents and Canton merchants argued over who should benefit most from the reform. Supercargoes Andrew Reid, Charles Rigby, and Frederick Pigou delayed the receipt of their tea purchases, demanding a full rebate of the supplemental tax from merchants with whom they already held contracts. However, the Chinese merchants refused to return the remitted duties on any goods already purchased “on pretence that we did not stipulate it in our Contract.”"), _c('a', {
    attrs: {
      "id": "ch1notes-71"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes71",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("71")])]), _vm._v(" More insulting to the company agents, Tsong-ton, the Hoppo who had announced the tax edict, insisted that all Europeans attend a reading of it and “prostrate themselves, kneeling on both their knees” in honor of the emperor. The Hoppo threatened them with “ill consequences . . . & possibly with an entire Exclusion from Commerce with China” if they refused to comply."), _c('a', {
    attrs: {
      "id": "ch1notes-72"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes72",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("72")])]), _vm._v(" English merchants considered “kowtowing” too high a price to pay for doing business in the tightly regulated Chinese market.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The real price to pay for doing business, however, was a growing imbalance of trade with China. Although the EIC managed to establish a place for itself in the Canton system and to surpass other European companies in the purchase of tea, England had few export products that sold well on the Chinese market. When asked in 1734 “what sort of European or British Goods will sell best in China,” the EIC agents found that only common lead found a market; English woolens, a staple in the Atlantic trade, fell flat in a country used to fine cottons and silk."), _c('a', {
    attrs: {
      "id": "ch1notes-73"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes73",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("73")])]), _vm._v(" Clocks and curios worked well as presents for Mandarins and Hoppos, but the EIC agents had to ship vast amounts of silver bullion and coins to purchase goods in China. Although restricted in the seventeenth century, Charles II loosened English monetary policy after the Restoration, allowing the EIC and other traders to export silver bullion."), _c('a', {
    attrs: {
      "id": "ch1notes-74"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes74",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("74")])]), _vm._v(" During the first decade of the eighteenth century, a total of £8,973,875 sterling was shipped to India, China, Japan, and Batavia to purchase goods."), _c('a', {
    attrs: {
      "id": "ch1notes-75"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes75",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("75")])]), _vm._v(" Silver bullion made up 80 to 90 percent of all exports that the EIC carried to Canton in the first half of the eighteenth century."), _c('a', {
    attrs: {
      "id": "ch1notes-76"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes76",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("76")])]), _vm._v(" This gave rise to a great fear that "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("the nation’s wealth would be depleted through foreign trade. Carew Reynell, a Whig economic writer of the late seventeenth century, worried that “to the "), _c('em', [_vm._v("East-Indies")]), _vm._v(" we carry nothing but ready Money, and bring in again nothing worth anything but Spices.”")]), _c('a', {
    attrs: {
      "id": "ch1notes-77"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes77",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still, rather than draining the empire of wealth, as some political economists feared, silver gave the English commercial leverage in China. First, the EIC had to purchase silver and gold bullion for trade from London bankers, especially the Bank of England, or through European traders. For instance, the company purchased Spanish silver in Amsterdam to settle accounts with Lisbon and Cádiz merchants. Silver also made its way to India directly from Mexico via Manila, or the EIC minted its own silver coins in Bombay and Madras, which the company then exchanged for tea and silks in China."), _c('a', {
    attrs: {
      "id": "ch1notes-78"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes78",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("78")])]), _vm._v(" Indeed, from the mid-sixteenth century Spanish silver flowed through Manila to the Portuguese at Macao, then on to the EIC in India, which fueled the expansion of Chinese commercial markets. By the eighteenth century, silver had become the most important commodity for the Chinese market, commanding prices that were 50 percent higher than in European markets, which helped compensate merchants for the cost of shipping goods to Asia."), _c('a', {
    attrs: {
      "id": "ch1notes-79"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes79",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("79")])]), _vm._v(" Thus, silver became a necessary incentive to the production and distribution networks for tea. Chinese merchants had to advance cash (sometimes up to 70 or 80 percent of the cost) to growers in the countryside when they ordered tea for the coming trade season. In contracts with the EIC agents, they demanded advance payments or loans to pay off government officials and buy product for sale in Canton. In its efforts to corner the tea markets, the EIC, courting the cooperation of Co-Hong merchants, at times prepaid up to 50 percent of the negotiated contract price."), _c('a', {
    attrs: {
      "id": "ch1notes-80"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes80",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("80")])]), _vm._v(" In 1734, for instance, EIC agents agreed to advance Tingua “a Couple of Chests of Treasure which he said at this juncture would be of great service to him in buying up the Hyson Tea in the country.” Whereas prepaying a contract provided assurances to tea producers and stabilized the price of tea to some extent, the EIC also used loans and advances to leverage contract concessions from Chinese merchants. The cash advance to Tingua in 1734 was made to “facilitate his Complyance with the Contract.”"), _c('a', {
    attrs: {
      "id": "ch1notes-81"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes81",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("81")])]), _vm._v(" Throughout the 1730s, as it attempted to corner the tea market, the EIC hoped to both placate and frustrate the Co-Hong.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Far from fulfilling the mercantilist aspirations of dominating foreign trade, by the 1740s the EIC struggled with logistical and financial problems. The company’s government-sanctioned trade monopoly may have cut down on "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("competition, and using cash to purchase goods may have given it leverage with Canton merchants, but commercial entanglements in China, especially the prolonged attempt to corner the tea market, proved a double-edged sword. Indeed, tea had quickly become the commodity that the EIC relied on for its survival, a commodity that helped fund its expansion into South Asia and China. Easily transported, relatively durable, and one of the most profitable commodities available in the East Indies, tea had risen to between 20 and 40 percent of all the company’s Asia trade by midcentury, with millions of pounds imported annually.")]), _c('a', {
    attrs: {
      "id": "ch1notes-82"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes82",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("82")])]), _vm._v(" Yet, the proliferation of tea in the early eighteenth century came at a price. As the EIC alienated competing European merchant companies, faced a rising tide of smuggled goods, and lost reexport markets in Holland and Germany, it found itself burdened with far more tea than it could possibly sell in England alone. Strangely, the company continued to pursue adamantly a monopoly on tea, even as a glut of product filled its warehouses. The directors instructed agents in Canton for the 1732 trade season to keep any discussion of “our Marketts in England being over stock’d with green tea” private, especially from the Chinese, yet suggested that the supercargoes still “make as brisk an enquiry after green tea now as when it was at its highest demand in England.”"), _c('a', {
    attrs: {
      "id": "ch1notes-83"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch1notes83",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("83")])]), _vm._v(" The EIC feared a glut would erode profits, so it attempted to raise the sale price artificially by withholding surplus tea from sale, usually for an average of seventeen months, and setting minimum prices for teas at auction. Perhaps the EIC directors determined that if they created a demand for tea, they could retain their commercial interests in China. With a warehouse full of “engrossed” tea on hand, the company turned to the maturing British colonies across the Atlantic to find Hakluyt’s promised new markets to “vente” its goods.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1df5fbfe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch1.vue
// module id = 84
// module chunks = 0